@if (aiEnabled) {
    <eff-expansion-panel
        [contentTemplate]="content"
        [panelOpenState]="true"
        [title]="'effAiReviewInfoBox.panelTitle' | t"
        class="eff-details-panel"
        data-uiid="new-eff-ai-review-info-box"
    >
        <ng-template #content>
            <div class="d-flex flex-column gap-3">
                <div class="regular-text-small">{{ 'effAiReviewInfoBox.disclaimer' | t }}</div>
                <eff-button
                    icon="auto_awesome_outlined"
                    size="medium-size"
                    [disabled]="loading"
                    [text]="
                        (loading
                            ? 'effAiReviewInfoBox.loading'
                            : review
                              ? 'effAiReviewInfoBox.refresh'
                              : 'effAiReviewInfoBox.getReview'
                        ) | t
                    "
                    data-uiid="new-eff-ai-review-info-box-get-review-button"
                    (click)="getReview()"
                ></eff-button>

                @if (review) {
                    <div class="d-flex flex-column gap-1">
                        <div class="bold-text-small">
                            {{ 'effAiReviewInfoBox.conclusionSupported' | t }}
                            {{ 'effAiReviewInfoBox.conclusion' + review.conclusionSupported | t }}
                        </div>
                        <div class="regular-text-small multiple-whitespaces">{{ review.summary }}</div>
                    </div>

                    @if (review.findings.length > 0) {
                        <div class="d-flex flex-column gap-2">
                            <div class="bold-text-small">{{ 'effAiReviewInfoBox.findings' | t }}</div>
                            @for (finding of review.findings; track $index) {
                                <div class="finding" [class]="'severity-' + finding.severity.toLowerCase()">
                                    <div class="bold-text-small">
                                        {{ 'effAiReviewInfoBox.severity' + finding.severity | t }} ·
                                        {{ finding.title }}
                                    </div>
                                    <div class="regular-text-small multiple-whitespaces">{{ finding.detail }}</div>
                                    @if (finding.references.length > 0) {
                                        <div class="regular-text-small references">{{ finding.references.join(", ") }}</div>
                                    }
                                    <div class="feedback">
                                        <button
                                            type="button"
                                            class="feedback-button"
                                            [class.selected]="getFeedback(itemType.Finding, $index) === true"
                                            [attr.aria-label]="'effAiReviewInfoBox.relevant' | t"
                                            [title]="'effAiReviewInfoBox.relevant' | t"
                                            data-uiid="new-eff-ai-review-info-box-relevant-button"
                                            (click)="giveFeedback(itemType.Finding, $index, finding.title, true)"
                                        >
                                            <eff-icon icon="thumb_up_outlined" size="small-size"></eff-icon>
                                        </button>
                                        <button
                                            type="button"
                                            class="feedback-button"
                                            [class.selected]="getFeedback(itemType.Finding, $index) === false"
                                            [attr.aria-label]="'effAiReviewInfoBox.notRelevant' | t"
                                            [title]="'effAiReviewInfoBox.notRelevant' | t"
                                            data-uiid="new-eff-ai-review-info-box-not-relevant-button"
                                            (click)="giveFeedback(itemType.Finding, $index, finding.title, false)"
                                        >
                                            <eff-icon icon="thumb_down_outlined" size="small-size"></eff-icon>
                                        </button>
                                    </div>
                                </div>
                            }
                        </div>
                    }

                    @if (review.improvements.length > 0) {
                        <div class="d-flex flex-column gap-1">
                            <div class="bold-text-small">{{ 'effAiReviewInfoBox.improvements' | t }}</div>
                            <ul class="improvements">
                                @for (improvement of review.improvements; track $index) {
                                    <li class="regular-text-small">
                                        <div class="d-flex align-items-start justify-content-between gap-2">
                                            <span>{{ improvement }}</span>
                                            <div class="feedback">
                                                <button
                                                    type="button"
                                                    class="feedback-button"
                                                    [class.selected]="getFeedback(itemType.Improvement, $index) === true"
                                                    [attr.aria-label]="'effAiReviewInfoBox.relevant' | t"
                                                    [title]="'effAiReviewInfoBox.relevant' | t"
                                                    data-uiid="new-eff-ai-review-info-box-relevant-button"
                                                    (click)="giveFeedback(itemType.Improvement, $index, improvement, true)"
                                                >
                                                    <eff-icon icon="thumb_up_outlined" size="small-size"></eff-icon>
                                                </button>
                                                <button
                                                    type="button"
                                                    class="feedback-button"
                                                    [class.selected]="getFeedback(itemType.Improvement, $index) === false"
                                                    [attr.aria-label]="'effAiReviewInfoBox.notRelevant' | t"
                                                    [title]="'effAiReviewInfoBox.notRelevant' | t"
                                                    data-uiid="new-eff-ai-review-info-box-not-relevant-button"
                                                    (click)="giveFeedback(itemType.Improvement, $index, improvement, false)"
                                                >
                                                    <eff-icon icon="thumb_down_outlined" size="small-size"></eff-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                }
                            </ul>
                        </div>
                    }
                }
            </div>
        </ng-template>
    </eff-expansion-panel>
}
